import { FC } from 'react';

import Button from 'molecules/Button';
import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import { CallOutCardConfigProps } from 'organisms/Cards/CallOut/config';
import { callOutContainer } from 'organisms/Cards/CallOut/styles';

const CallOut: FC<CallOutCardConfigProps> = ({ heading, body, button, image, color, mediaType, iconId }) => {
  const safeColor = color === 'green' ? color : 'green';
  const hasBody = body && body.replace(/<[^>]*>/g, '').trim().length > 0;
  const hasMultipleElements = [heading, hasBody, button?.label].filter(Boolean).length > 1;
  const hasImage = mediaType === 'image' && !!image?.file?.url;
  const hasIcon = mediaType === 'icon' && !!iconId;
  const hasMedia = hasImage || hasIcon;

  return (
    <div className={callOutContainer({ color: safeColor, hasMedia })}>
      {hasIcon && iconId && <Icon icon={iconId} className="size-20 shrink-0 text-gray-900 sm:size-14" />}
      {hasImage && image?.file && (
        <Image
          url={image.file.url}
          alt={image?.alt || 'callout'}
          width={image.file.width}
          height={image.file.height}
          className="size-20 shrink-0 sm:size-14"
        />
      )}
      <div className={`flex flex-col items-start ${hasMultipleElements ? 'gap-4' : ''}`}>
        {heading && <div className="text-xl font-bold text-gray-900 sm:text-display-xs sm:font-medium">{heading}</div>}
        {hasBody && <RichText text={body} className="text-md text-gray-900 sm:text-lg" />}
        {button?.label && (
          <Button
            hierarchy="tertiary"
            {...button}
            className="bg-primary-button-default !text-gray-900 hover:bg-primary-button-default hover:!text-gray-900"
          />
        )}
      </div>
    </div>
  );
};

export default CallOut;
